class StatisticType {
    constructor(public name: string,
                public value: StatisticsType,
                //wtf this does?
                public dateLimits: boolean) { }
}

export enum StatisticsType {
    NUMBER_OF_CUSTOMERS = 'NUMBER_OF_CUSTOMERS',
    TOTAL_CUSTOMERS = 'TOTAL_CUSTOMERS',
    OPPORTUNITIES = 'OPPORTUNITIES',
    OPPORTUNITY_ACTIONS = 'OPPORTUNITY_ACTIONS',
    CONVERSION = 'CONVERSION',
    CONVERSION_BY_CALCULATOR_NAME = 'CONVERSION_BY_CALCULATOR_NAME',
    CONVERSION_BY_CAMPAIGN_TYPE = 'CONVERSION_BY_CAMPAIGN_TYPE'
}

export const STATISTICS_TYPES_HOLDER = {
    enum: {
        NUMBER_OF_NEW_CUSTOMERS: new StatisticType('New customers', StatisticsType.NUMBER_OF_CUSTOMERS, true),
        TOTAL_NUMBER_OF_CUSTOMERS: new StatisticType('Total customers', StatisticsType.TOTAL_CUSTOMERS, true),
        OPPORTUNITIES: new StatisticType('Opportunities', StatisticsType.OPPORTUNITIES, true),
        OPPORTUNITY_ACTIONS: new StatisticType('Opportunity Actions', StatisticsType.OPPORTUNITY_ACTIONS, true),
        CONVERSION: new StatisticType('Conversion', StatisticsType.CONVERSION, true),
        CONVERSION_BY_CALCULATOR_NAME: new StatisticType('Conversion By Calculator', StatisticsType.CONVERSION_BY_CALCULATOR_NAME, true),
        CONVERSION_BY_CAMPAIGN_TYPE: new StatisticType('Conversion By Campaign', StatisticsType.CONVERSION_BY_CAMPAIGN_TYPE, true)
    },
    findByValue: function (value: string): StatisticType {
        for (let prop in this.enum) {
            if (this.enum.hasOwnProperty(prop) && this.enum[prop].value === value) {
                return this.enum[prop];
            }
        }
        throw Error('No such enum elem')
    }
};
